import { render, staticRenderFns } from "./VContainer.vue?vue&type=template&id=6c472f9f&"
import script from "./VContainer.vue?vue&type=script&lang=js&"
export * from "./VContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports